<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import { TripOverviewPageComponentAsyncImport } from '@apps/main/modules/router/tripPlannerRoute';

import { useBackgroundComponentsPreload } from '@libs/utils';

import WebComponentsInit from '../../core/components/WebComponentsInit.vue';
import { usePerformanceStore } from '../../core/stores';
import { AutoCompleteType } from '../../modules/autoComplete';

import BuildYourTripLayout from './components/BuildYourTripLayout.vue';
import BuildYourTripModals from './components/BuildYourTripModals.vue';
import BuildYourTripPanel from './components/BuildYourTripPanel.vue';
import { useBuildYourTripModalsStore } from './stores/buildYourTripModalsStore';

const buildYourTripModalsStore = useBuildYourTripModalsStore();
const performanceStore = usePerformanceStore();

const preloadComponents = useBackgroundComponentsPreload([
  TripOverviewPageComponentAsyncImport,
]);

onMounted(() => preloadComponents.start());

onUnmounted(() => preloadComponents.stop());
</script>

<template>
  <BuildYourTripModals />
  <WebComponentsInit />

  <BuildYourTripLayout
    @vue:mounted="performanceStore.trackBuildYourTripPageRenderedPerformance()"
  >
    <BuildYourTripPanel
      @build-your-trip="
        buildYourTripModalsStore.openDestinationSelectorModal(
          '',
          undefined,
          AutoCompleteType.Destination
        )
      "
    />
  </BuildYourTripLayout>
</template>
